import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Link } from "@/components/common/Link";
const testimonials = [{
  author: "Marcus V.",
  quote: "Lavers helped us identify $2M in annual operational waste. Their efficiency-first approach is truly unmatched in the industry.",
  position: "Operations Director, Logistics Plus",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1601078/img/avatar_jane_d.png"
}, {
  author: "Elena R.",
  quote: "A decade of experience shows. They didn't just consult; they implemented a revenue strategy that grew our margins by 40%.",
  position: "Managing Partner, Insight FinTech",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1601078/img/avatar_john_s.png"
}, {
  author: "David K.",
  quote: "The precision they bring to business modeling transformed our entire cost structure within just six months of engagement.",
  position: "CFO, Horizon Manufacturing",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1601078/img/avatar_sarah_l.png"
}];
export default function SuccessStories() {
  return <section data-section-id="17068" id="client-success-stories" className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/10 via-background to-background pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-sm font-mono text-primary tracking-widest uppercase mb-4">
            Client Impact
          </h2>
          <h3 className="text-3xl md:text-5xl font-sans font-bold tracking-tighter text-foreground">
            Strategic Growth & Efficiency
          </h3>
        </div>

        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="md:basis-full pl-0">
                <div className="relative flex flex-col items-center justify-center p-6 md:p-12 min-h-[400px]">
                  {}
                  <Quote className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 md:w-64 md:h-64 text-primary opacity-[0.05] -z-10 rotate-12" strokeWidth={1} />

                  {}
                  <blockquote className="relative z-10 text-center max-w-3xl mx-auto mb-10">
                    <p className="text-2xl md:text-4xl lg:text-5xl font-serif italic leading-tight md:leading-tight text-foreground/95 antialiased">
                      &ldquo;{testimonial.quote}&rdquo;
                    </p>
                  </blockquote>

                  {}
                  <div className="flex items-center gap-4 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-200">
                    <SafeHydrate><Avatar className="h-14 w-14 border border-border shadow-md">
                      <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                      <AvatarFallback className="bg-primary/20 text-primary font-mono font-bold">
                        {testimonial.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div className="text-left">
                      <div className="font-sans font-bold text-lg text-foreground tracking-tight">
                        {testimonial.author}
                      </div>
                      <div className="font-mono text-xs uppercase tracking-wider text-primary">
                        {testimonial.position}
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="hidden md:block">
            <CarouselPrevious className="left-4 md:-left-12 bg-background/80 border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 hover:scale-110 backdrop-blur-md rounded-sm" />
            <CarouselNext className="right-4 md:-right-12 bg-background/80 border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 hover:scale-110 backdrop-blur-md rounded-sm" />
          </div>
          
          {}
          <div className="flex md:hidden justify-center gap-4 mt-8">
             <CarouselPrevious className="static translate-y-0 translate-x-0 bg-background/80 border-border hover:bg-primary hover:text-primary-foreground rounded-sm" />
             <CarouselNext className="static translate-y-0 translate-x-0 bg-background/80 border-border hover:bg-primary hover:text-primary-foreground rounded-sm" />
          </div>
        </Carousel>
      </div>
    </section>;
}